<!--roadmap section-->
<section id="roadmap" class="roadmap  pt-5 pb-5 pb-md-0 bg-white" [ngClass]="{'arabic': lang === 'ar'}">
  <div class="row pt-5 justify-content-center ">
    <div class="col-md-9">
      <h5 class="text-center fw-semibold title pt-md-5 pb-2 roadmap-title">
        {{"roadmap-title" | translate}}
      </h5>
      <h2 class="text-center fw-semibold mb-md-5 mb-3 title pb-2 roadmap-head">
        {{"roadmap_head" | translate}}
      </h2>
      <!-- <p class="sub-title text-dark-blue text-center py-4 fw-fw-regular"> {{"roadmap_para" | translate}}</p> -->
      <div class="text-center d-none d-sm-block">
        <!-- <img src="/assets/images/avtar-roadmap.svg" class="img-fluid w-auto mt-1 mb-3 pb-1 avtar-roadmap" alt="" > -->
        <!-- <div class="lottie-animation mt-5 mb-5 pb-3">
          <ng-lottie
            [styles]="styles"
            [options]="options" 
            (animationCreated)="onAnimate($event)">
          </ng-lottie>
        </div> -->
      </div>
    </div>
  </div>

  <div class="phase-wrapper">
    <div class=" mt-0  pt-0 pb-md-5 roadmap-desktop" *ngIf="!isMobile">
      <owl-carousel-o [options]="slideOption" dir="ltr" (change)="getData($event)" #owlCar>
        <ng-template carouselSlide *ngFor="let item of timeline; let i = index;" id="{{i}}">
          <ul class="timeline flex-md-nowrap flex-wrap">
            <li [class.active]="item.title === this.activeTab" [class.active-text]="isTabActive(item)"
              class="active-tl text-start" (click)="setActiveClass(item.title); curIndx = i">
              <div class="inner-content mt-4">
                <h4 class="text-start mb-3 text-blue" translate>{{item.title}}</h4>
                <ul>
                  <li *ngFor="let obj of item.data; let j = index" [ngClass]="{
                    'li-style': obj.pass, 
                    'marginTopClass': item.title === 'road2_title' && j === 3
                  }">
                    <div class="d-inline-flex justify-content-start">
                      <span class="d-inline-block mwx-100" *ngIf="item?.staking != ''" translate>{{item.staking}}</span>
                      {{obj.title | translate}}
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>

  <div class=" mt-0 mt-md-5 pt-0 py-md-5 roadmap-mob mb-4" *ngIf="isMobile">
    <owl-carousel-o [options]="slideOption">
      <ng-template carouselSlide *ngFor="let item of timeline;">
        <ul class="timeline d-flex align=items-start flex-md-nowrap flex-wrap">
          <li class="active-ml text-start m-0">
            <div class="inner-content pt-5 m-0 ">
              <h4 class="text-blue text-start mb-3" translate>{{item.title}}</h4>
              <ul class="text-center mobile">
                <li *ngFor="let obj of item.data" [ngClass]="{'li-style': obj.pass}">
                  <div class="d-inline-flex justify-content-start "><span class="d-inline-block mwx-100"
                      *ngIf="item?.staking != ''" translate>{{item.staking}}</span>{{obj.title | translate}}</div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </ng-template>
    </owl-carousel-o>
  </div>
</section>